import React, { Fragment } from "react";
import { Route } from "react-router";
import Login from "./Login/Login";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import Logout from "./Logout/Logout";
import Signup from "./Signup/Signup";
import AcceptInvite from "./AcceptInvite/AcceptInvite";
import Impersonate from "./Impersonate/Impersonate";
import Unimpersonate from "./Unimpersonate/Unimpersonate";
import ForgotPasswordInit from "./ForgotPassword/ForgotPasswordInit";
import ForgotPasswordSent from "./ForgotPassword/ForgotPasswordSent";
import EmailConfirmation from "./EmailConfirmation/EmailConfirmation";

const AccountWrapper = () => {
  //const account = useAppState("account");
  //const router = useAppState("router");

  // mick+company2@bluechilli.com
  /*
      useEffect(() => {
      console.log("PUSHING HERE BECAUSE OF isLOGGED IN CHANGE");
      //router.push("/");
      //account.state.isLoggedIn
    }, []);
  */
  return (
    <Fragment>
      <Header />
      <Route path="/user/login" exact component={Login} />
      <Route path="/user/logout" exact component={Logout} />
      <Route path="/user/signup" exact component={Signup} />
      <Route path="/user/acceptInvite" exact component={AcceptInvite} />
      <Route path="/user/impersonate" exact component={Impersonate} />
      <Route path="/user/unimpersonate" exact component={Unimpersonate} />
      <Route path="/user/confirm-email" exact component={EmailConfirmation} />
      <Route path="/user/forgot" exact component={ForgotPasswordInit} />
      <Route path="/user/forgotdone" exact component={ForgotPasswordSent} />
      <Footer />
    </Fragment>
  );
};

export default AccountWrapper;
